import { UserState } from "@gx1/gx-npm-lib";
import { init } from "g-npm-analytics/lib/gTrackWrapper";

const identifyAmplitude = async (event: { channel: string, payload: UserState | undefined }) => {
  try {
    if (!["qa", "prod"].includes(window.appEnv)) {
      throw new Error(`Invalid environment, env: ${window.appEnv}`);
    }
    const userState = event.payload;
    if (!userState?.hasUserState) {
      throw new Error("No user state is available");
    }
    if (!userState?.gcomUserIdHash) {
      throw new Error("No user gcom hash is available");
    }
    await init({
      autocapture: {
        elementInteractions: {
          cssSelectorAllowlist: [
            "button",
            "a",
            "[role=\"button\"]"
          ],
        },
        // TODO networkTracking: {},
      },
      enableSessionReplay: true,
      enableGuideSurvey: true,
      env: window.appEnv,
      eventProperties: {
        appName: "buysmart",
      },
      userProperties: {
        userIdHash: userState.gcomUserIdHash,
      },
    });

    console.info("Amplitude initialized successfully"); // eslint-disable-line no-console
  } catch (err) {
    console.info(`Amplitude initialization failed. ${(err as Error)?.message || ""}`); // eslint-disable-line no-console
  }
};

const shutdownAmplitude = async () => {
  console.info("TODO Amplitude shutdown is not implemented yet"); // eslint-disable-line no-console
};

export const initializeAmplitude = async () => {
  await window.eventBus.subscribe("USER_STATE", true, identifyAmplitude);
  await window.eventBus.subscribe("USER_LOGGED_OUT", shutdownAmplitude);
};
